import { Col, Container, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Contact } from "../components/contact"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"

import officer_001 from "../images/officer_001.jpg"
import officer_002 from "../images/officer_002.png"
import access_map from "../images/map.png"


import img_logo from "../images/logo.svg"

interface IOutlineProps {
  title: string
  text: string
  part?: boolean
}

interface IHistoryProps {
  year: string,
  month: string,
  event: string
}

const HistoryItem = ({ year, month, event }: IHistoryProps) => {
  const { i18n } = useTranslation()

  return (
    <Row className="mb-2">
      <Col xs="3" className="text-end">
        {year}
        {i18n.language === "ja" ? "年" : "."}
        {month}
        {i18n.language === "ja" && "月"}
      </Col>
      <Col xs="9" className="text-start">
        <p className="mb-2">{event}</p>
      </Col>
    </Row>
  )
}

const OutlineItem = ({ title, text, part }: IOutlineProps) => (
  <Row>
    <Col xs="3">
      <p className={`fw-bold ${part ? "mb-0" : ""}`.trim()}>{title}</p>
    </Col>
    <Col xs="9">
      <p className={part ? "mb-0" : undefined}>{text}</p>
    </Col>
  </Row>
)

export const CompanyPage = () => {
  const { t } = useTranslation("translations", { keyPrefix: "COMPANY_INFO" })

  return (
    <Layout title="COMPANY" subtitle={t("SUBTITLE")}>
      <Head title="COMPANY" />
      <Container>
        <div className="text-center mx-auto my-5">
          <img className="mx-auto" src={img_logo} style={{ height: "60px" }} alt="header-logo" />
          <p>{t("COMPANY_NAME")}</p>
        </div>
        <div className="text-center" style={{ marginTop: "100px", marginBottom: "100px" }}>
          <h2>{t("SLOGAN")}</h2>
        </div>
      </Container>
      <div style={{ boxShadow: "0 3px 5px -3px rgba(0,0,0,0.2) inset, 0 -3px 5px -3px rgba(0,0,0,0.2) inset", backgroundColor: "#FAFFF2" }} className="py-5">
        <Container>
          <div className="text-center">
            <h2 className="mt-4 mb-0">PHILOSOPHY</h2>
            <small>{t("PHILOSOPHY.SUBTITLE")}</small>
            <div className="my-5">
              <p className="mb-4">{t("PHILOSOPHY.1")}</p>
              <p className="mb-4">{t("PHILOSOPHY.2")}</p>
              <p className="mb-4">{t("PHILOSOPHY.3")}</p>
              <p className="mb-4">{t("PHILOSOPHY.4")}</p>
            </div>
          </div>
        </Container>
      </div>
      <Container>
        <Row>
          <Col md="12" className="text-center my-5">
            <h2 className="mb-0">MESSAGE</h2>
            <small>{t("MESSAGE.SUBTITLE")}</small>
          </Col>
          <Col md="4" className="text-center mb-4">
            <img src={officer_001} alt="officer_001" className="w-100 rounded" />
          </Col>
          <Col md="8" className="px-5 mb-5">
            <h4 className="text-center mb-4">{t("MESSAGE.REPRESENTIVE_DIRECTOR.NAME")}</h4>
            <p>{t("MESSAGE.REPRESENTIVE_DIRECTOR.1")}</p>
            <p>{t("MESSAGE.REPRESENTIVE_DIRECTOR.2")}</p>
            <p>{t("MESSAGE.REPRESENTIVE_DIRECTOR.3")}</p>
            <p>{t("MESSAGE.REPRESENTIVE_DIRECTOR.4")}</p>
            <p>{t("MESSAGE.REPRESENTIVE_DIRECTOR.5")}</p>
            <p>{t("MESSAGE.REPRESENTIVE_DIRECTOR.6")}</p>
          </Col>
          <Col md="8">
            <h4 className="text-center mb-4">{t("MESSAGE.SENIOR_MANAGING_DIRECTOR.NAME")}</h4>
            <p>{t("MESSAGE.SENIOR_MANAGING_DIRECTOR.1")}</p>
            <p>{t("MESSAGE.SENIOR_MANAGING_DIRECTOR.2")}</p>
            <p>{t("MESSAGE.SENIOR_MANAGING_DIRECTOR.3")}</p>
          </Col>
          <Col md="4" className="text-center mb-4">
            <img src={officer_002} alt="officer_002" className="w-100 rounded" />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col md="12" className="text-center mt-5 mb-4">
            <h2 className="mb-0">HISTORY</h2>
            <small>{t("HISTORY.SUBTITLE")}</small>
          </Col>
          <Col xs="12">
            <HistoryItem year="2005" month="06" event={t("HISTORY.2005_06")} />
            <HistoryItem year="2005" month="07" event={t("HISTORY.2005_07")} />
            <HistoryItem year="2009" month="06" event={t("HISTORY.2009_06")} />
            <HistoryItem year="2009" month="08" event={t("HISTORY.2009_08")} />
            <HistoryItem year="2009" month="10" event={t("HISTORY.2009_10")} />
            <HistoryItem year="2010" month="01" event={t("HISTORY.2010_01")} />
            <HistoryItem year="2010" month="04" event={t("HISTORY.2010_04")} />
            <HistoryItem year="2010" month="05" event={t("HISTORY.2010_05")} />
            <HistoryItem year="2010" month="07" event={t("HISTORY.2010_07")} />
            <HistoryItem year="2011" month="10" event={t("HISTORY.2011_10")} />
            <HistoryItem year="2020" month="04" event={t("HISTORY.2020_04")} />
            <HistoryItem year="2025" month="10" event={t("HISTORY.2025_10")} />
            <HistoryItem year="2026" month="02" event={t("HISTORY.2026_02")} />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col md="12" className="text-center mt-5 mb-4">
            <h2 className="mb-0">ACCESS MAP</h2>
            <small>{t("ACCESS_MAP.SUBTITLE")}</small>
          </Col>
          <Col md="6" className="text-center mb-4">
            <img src={access_map} alt="access_map" className="w-100 rounded" />
          </Col>
          <Col md="2"> </Col>
          <Col md="4">
            <p><b>{t("ACCESS_MAP.TSURUMAI_LINE.TITLE")}</b></p>
            <p>{t("ACCESS_MAP.TSURUMAI_LINE.1")}</p>
            <p>{t("ACCESS_MAP.TSURUMAI_LINE.2")}</p>
            <p><b>{t("ACCESS_MAP.SAKURADORI_LINE.TITLE")}</b></p>
            <p>{t("ACCESS_MAP.SAKURADORI_LINE.1")}</p>
            <p>{t("ACCESS_MAP.SAKURADORI_LINE.2")}</p>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col md="12" className="text-center mt-5 mb-4">
            <h2 className="mb-0">OUTLINE</h2>
            <small>{t("OUTLINE.SUBTITLE")}</small>
          </Col>
          <Col md={{ span: 5, offset: 1 }}>
            <OutlineItem title={t("OUTLINE.COMPANY_NAME.LABEL")} text={t("OUTLINE.COMPANY_NAME.VALUE")} />
            <OutlineItem title={t("OUTLINE.DATE_OF_ESTABLISHMENT.LABEL")} text={t("OUTLINE.DATE_OF_ESTABLISHMENT.VALUE")} />
            <OutlineItem title={t("OUTLINE.CAPITAL.LABEL")} text={t("OUTLINE.CAPITAL.VALUE")} />
            <OutlineItem title={t("OUTLINE.ADDRESS.LABEL")} text={t("OUTLINE.ADDRESS.VALUE_1")} part />
            <OutlineItem title="" text={t("OUTLINE.ADDRESS.VALUE_2")} />
            <OutlineItem title={t("OUTLINE.REPRESENTIVE_DIRECTOR.LABEL")} text={t("OUTLINE.REPRESENTIVE_DIRECTOR.VALUE")} />
            <OutlineItem title={t("OUTLINE.NUMBER_OF_EMPLOYEES.LABEL")} text={t("OUTLINE.NUMBER_OF_EMPLOYEES.VALUE")} />
          </Col>
          <Col md="5">
            <OutlineItem title={t("OUTLINE.BUSINESS_CONTENTS.LABEL")} text={t("OUTLINE.BUSINESS_CONTENTS.VALUE_1")} part />
            <OutlineItem title="" text={t("OUTLINE.BUSINESS_CONTENTS.VALUE_2")} part />
            <OutlineItem title="" text={t("OUTLINE.BUSINESS_CONTENTS.VALUE_3")} />
            <OutlineItem title={t("OUTLINE.AFFILIATION.LABEL")} text={t("OUTLINE.AFFILIATION.VALUE_1")} part />
            <OutlineItem title="" text={t("OUTLINE.AFFILIATION.VALUE_2")} />
            <OutlineItem title={t("OUTLINE.BANKS.LABEL")} text={t("OUTLINE.BANKS.VALUE_1")} part />
            <OutlineItem title="" text={t("OUTLINE.BANKS.VALUE_2")} />
          </Col>
          <Col md="12" className="text-center mt-1 mb-5">
            <small>{t("OUTLINE.LAST_UPDATE")}</small>
          </Col>
        </Row>
      </Container>
      <Contact />
    </Layout>
  )
}